var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9846 0.848261C19.0576 0.848261 17.146 0.848261 15.2191 0.848261C13.2921 0.848261 11.3805 0.832846 9.45355 0.863678C4.22759 0.940757 0.666535 4.4864 0.604872 9.69694C0.558624 13.2426 0.57404 16.7882 0.604872 20.3339C0.651119 25.6369 4.19676 29.2288 9.4998 29.2596C17.1769 29.3059 24.854 29.3059 32.531 29.2596C37.757 29.2288 41.3181 25.6369 41.3797 20.4264C41.426 16.8807 41.4106 13.3351 41.3797 9.78944C41.3335 4.47098 37.7878 0.909924 32.4848 0.848261C28.6617 0.832845 24.8231 0.863677 20.9846 0.848261Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7915 14.9537C16.7915 13.4276 16.7761 11.9168 16.7915 10.3906C16.7915 9.18822 17.3465 8.8799 18.3793 9.48111C21.108 11.0381 23.8366 12.5797 26.5497 14.1675C27.598 14.7842 27.5672 15.3854 26.4727 15.9866C23.7441 17.5282 20.9692 19.0081 18.2098 20.5034C17.2694 21.0122 16.8069 20.6576 16.7915 19.6556C16.7761 18.0986 16.7915 16.5261 16.7915 14.9537Z",
    fill: "#FFF101"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.98b2f7407972ff21567627ae4f0add19.svg";
export { ForwardRef as ReactComponent };